﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import NoteViewer from '../NoteViewer';
import { CalibrationRequirement } from '../../models/Metrology/calibration-requirement';
import { CalibrationSummary } from '../../models/Metrology/calibration-summary';
import { MeasurementType } from '../../models/Metrology/measurement-type';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, NoteType } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { ToastProps } from '../../models/toast-props';
import { CrudFunctions } from '../../utilities/crud-functions';
import { PWDates } from '../../utilities/pw-dates';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    Button as ColumnButton,
    HeaderFilter,
    Toolbar,
    Popup,
    Form,
    Lookup,
    Item as ToolbarItem,
    Editing,
    Paging,
    Pager,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';
import Button from 'devextreme-react/button';
import Toast from 'devextreme-react/toast';
import { Popup as DialogPopup } from 'devextreme-react/popup';


const parts = window.location.href.split('/');
const assetId = parts[parts.length - 1];

let key = 0;

export default function MetrologyForm() {
    const [measurementTypes, setMeasurementTypes] =
        useState<MeasurementType[]>();

    const [selectedMeasurementType, setSelectedMeasurementType] =
        useState<MeasurementType>();

    const [calibrationRequirements, setCalibrationRequirements] =
        useState<CalibrationRequirement[]>();

    const [selectedCalibrationRequirement, setSelectedCalibrationRequirement] =
        useState<CalibrationRequirement>();

    const [calibrationSummaries, setCalibrationSummaries] =
        useState<CalibrationSummary[]>();

    const [selectedCalibrationSummary, setSelectedCalibrationSummary] =
        useState<CalibrationSummary>();

    const [metrologyCategories, setMetrologyCategories] =
        useState<LookupItem[]>();

    const [metrologyStatusTypes, setMetrologyStatusTypes] =
        useState<LookupItem[]>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    useEffect(() => {
        getAllData();
    }, []);

    key++;
    const gridWidth = 'calc(90vw - 13em)';

    const calibrationSummariesTitle = `Calibration Requirements - ${selectedCalibrationRequirement &&
        selectedCalibrationRequirement.assetId ? selectedCalibrationRequirement.assetId : ''}`;

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Metrology</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="20rem" width={gridWidth}
                    dataSource={calibrationRequirements ? calibrationRequirements : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="calibrationRequirementId"
                    onSelectionChanged={onCalibrationRequirementSelectionChanged}
                    onRowValidating={onCalibrationRequirementRowValidating}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="8rem">
                        <ColumnButton name="edit" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onMeasurementTypeAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onMeasurementTypeInformationButtonClicked} />
                        <ColumnButton name="delete" />
                    </Column>

                    <Column dataField='assetId' dataType='string' width='6rem' />
                    <Column dataField='description' dataType='string' width='26rem' />
                    <Column dataField='calibrationRequired' dataType='boolean' width='10rem' />


                    {/*
                        >>calibrationRequirementTypeId?: number;

                    <Column dataField='manufacturerId' caption='Manufacturer' dataType='number' width='10rem'>
                        <Lookup dataSource={technologies ? technologies : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='technologyId' />
                    </Column>
                    
                    <Column dataField='frequencyId' caption='Frequency' dataType='number' width='10rem'>
                        <Lookup dataSource={technologies ? technologies : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='technologyId' />
                    </Column>
                    
                    */}

                    <Column dataField='dateLastCalibration' caption="Last Calibrated" dataType='date' width='10rem' />
                    <Column dataField='dateNextCalibration' caption="Next Calibration" dataType='date' width='10rem' />

                    {/*
                    <Column dataField='respPartyId' caption='Responsible Party' dataType='number' width='10rem'>
                        <Lookup dataSource={metrologyCategories ? metrologyCategories : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='id' />
                    </Column>
                    */}

                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title"> { }</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after' name="searchPanel" />
                        <ToolbarItem location='after' name="addRowButton" />
                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true}>

                        <Popup title="Measurement Type" showTitle={true} width="55rem" height="25rem" />
                        <Form>
                            <Item dataField="serialId" />
                            <Item dataField="description" colSpan={2} />
                            <Item dataField="calibrationRequired" />
                            <Item dataField="dateLastCalibration" />
                            <Item dataField="dateNextCalibration" />
                        </Form>
                    </Editing>

                </DataGrid>
            </div>


            <div className="pw-margin-top-05">
                <DataGrid
                    height="20rem" width={gridWidth}
                    dataSource={selectedCalibrationRequirement &&
                        selectedCalibrationRequirement.summaries ?
                        selectedCalibrationRequirement.summaries : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="calibrationSummaryId"
                    onSelectionChanged={onCalibrationRequirementSelectionChanged}
                    onRowValidating={onCalibrationRequirementRowValidating}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="8rem">
                        <ColumnButton name="edit" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onMeasurementTypeAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onMeasurementTypeInformationButtonClicked} />
                        <ColumnButton name="delete" />

                      


                    </Column>



                    <Column dataField='dateCalibrated' dataType='date' width='10rem' />
                    <Column dataField='referenceLocation' dataType='string' width='20rem' />
                    
                    

                    {/*
                    calibrationSummaryId?: string;
                    calReqId?: string;
                    measurementTypeId?: string;
                    serialId?: string;
                    dateCalibrated?: Date;
                    referenceLocation?: string;
                    calibratedBy?: string;
                    reviewApprovalString?: string;
                    reviewerInitials?: string;
                    reviewDate?: Date;
                    dateNextCalibration?: Date;
                    
                    <Column dataField='measurementTypeId' caption='Manufacturer' dataType='number' width='10rem'>
                        <Lookup dataSource={technologies ? technologies : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='technologyId' />
                    </Column>
                                        
                    */}

                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">{calibrationSummariesTitle}</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after' name="searchPanel" />
                        <ToolbarItem location='after' name="addRowButton" />
                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true}>

                        <Popup title="Measurement Type" showTitle={true} width="55rem" height="25rem" />
                        <Form>
                            <Item dataField="serialId" />
                            <Item dataField="description" colSpan={2} />
                            <Item dataField="calibrationRequired" />
                            <Item dataField="dateLastCalibration" />
                            <Item dataField="dateNextCalibration" />
                        </Form>
                    </Editing>

                </DataGrid>
            </div>


            {/* 
                 <div className="pw-margin-top-05">
                <DataGrid
                    height="40rem" width={gridWidth}
                    dataSource={measurementTypes ? measurementTypes : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="measurementTypeId"
                    onSelectionChanged={onMeasurementTypeSelectionChanged}
                    onRowValidating={onMeasurementTypeRowValidating}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="8rem">
                        <ColumnButton name="edit" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onMeasurementTypeAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onMeasurementTypeInformationButtonClicked} />
                        <ColumnButton name="delete" />
                    </Column>

                    <Column dataField='serialId' dataType='string' width='6rem' />
                    <Column dataField='description' dataType='string' width='20rem' />

                    <Column dataField='manufacturer' dataType='string' width='10rem' />

                    <Column dataField='manufacturerId' caption='Manufacturer' dataType='number' width='10rem'>
                        <Lookup dataSource={technologies ? technologies : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='technologyId' />
                    </Column>
                    
                    <Column dataField='model' dataType='string' width='10rem' />
                    <Column dataField='manufacturerSerialNumber' dataType='string' width='10rem' />
                    <Column dataField='otherId' dataType='string' width='10rem' />

                    <Column dataField='measurementCategory' caption='Measurement Category' dataType='number' width='10rem'>
                        <Lookup dataSource={metrologyCategories ? metrologyCategories : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='id' />
                    </Column>

                    <Column dataField='frequency' dataType='number' width='8rem' />

                    <Column dataField='calibrationDate' dataType='date' width='9rem' />
                    <Column dataField='nextCalibrationDate' dataType='date' width='9rem' cellRender={renderRevalidationCell} />
                    <Column dataField='validationRequired' dataType='boolean' width='7rem' />


                    <Column dataField='location' dataType='string' width='8rem' />
                     
                    <Column dataField='manufacturerId' caption='Manufacturer' dataType='string' width='10rem'>
                        <Lookup dataSource={technologies ? technologies : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='technologyId' />
                    </Column>
                    
                    <Column dataField='status' dataType='number' width='10rem'>
                        <Lookup dataSource={metrologyStatusTypes ? metrologyStatusTypes : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='id' />
                    </Column>
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='after' name="searchPanel" />
                        <ToolbarItem location='after' name="addRowButton" />
                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true}>

                        <Popup title="Measurement Type" showTitle={true} width="55rem" height="25rem" />
                        <Form>
                            <Item dataField="serialId" />
                            <Item dataField="model" />
                            <Item dataField="description" colSpan={2} />
                            <Item dataField="measurementCategory" />
                            <Item dataField="manufacturerSerialNumber" />
                            <Item dataField="otherId" />
                            <Item dataField="frequency" />
                            <Item dataField="calibrationDate" />
                            <Item dataField="nextCalibrationDate" />
                            <Item dataField="validationRequired" />
                            <Item dataField="location" />
                            <Item dataField="status" />
                        </Form>
                    </Editing>

                </DataGrid>
            </div>
            */}

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width='25rem'
                    height='21rem'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={1200} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );


    function onCalibrationRequirementSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedCalibrationRequirement(e.selectedRowsData[0]);
        }
    }


    function onMeasurementTypeSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedMeasurementType(e.selectedRowsData[0]);
        }
    }

    async function onCalibrationRequirementRowValidating(e: any) {


    }


    async function onMeasurementTypeRowValidating(e: any) {
        if (e.oldData) {
            let measurementType = e.oldData as MeasurementType;

            if (measurementType) {
                let updatedMeasurementType = { ...measurementType, ...e.newData };

                updateMeasurementType(updatedMeasurementType)
                    .then(() => {
                        showToast("Measurement Type updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Measurement Type");
                    });
            }
        }
        else {
            if (e.newData) {
                let measurementType = e.newData as MeasurementType;


                await insertMeasurementType(measurementType)
                    .then(() => {
                        showToast("Measurement Type saved", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Measurement Type");
                    });
            }
        }
    }

    async function getCalibrationRequirements() {
        if (assetId) {
            await CrudFunctions.getData(`metrology/calibrationrequirements/${assetId}`)
                .then((data) => {
                    setCalibrationRequirements(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Calibration Requirements");
                });
        }
    }

    async function getMeasurementTypes() {
        await CrudFunctions.getData("metrology/measurementtypes")
            .then((data) => {
                setMeasurementTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Metrology Data");
            });
    }

    async function getMetrologyCategories() {
        await CrudFunctions.getData("common/metrologycategories")
            .then((data) => {
                setMetrologyCategories(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Metrology Categories");
            });
    }

    async function getMetrologyStatusTypes() {
        await CrudFunctions.getData("common/metrologystatustypes")
            .then((data) => {
                setMetrologyStatusTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Metrology Status Types");
            });
    }

    async function insertMeasurementType(measurementType: MeasurementType) {
        return await CrudFunctions.postData("metrology/measurementtype", measurementType);
    }

    async function updateMeasurementType(measurementType: MeasurementType) {
        return await CrudFunctions.putData("metrology/measurementtype", measurementType);
    }

    async function getAllData() {
        await Promise.all([
            getMeasurementTypes(),
            getMetrologyCategories(),
            getMetrologyStatusTypes(),
            getCalibrationRequirements()
        ]);
    }

    function onMeasurementTypeAuditButtonClicked(e: any) {


    }



    //navigation

    function goBack() {
        history.back();
    }

    //render

    function renderRevalidationCell(cellData: any) {
        const currentDate = new Date();
        const revalidationDate = cellData.data.nextCalibrationDate;

        if (revalidationDate) {
            const daysDifference = PWDates.getDifferenceInDays(currentDate, new Date(revalidationDate))

            if (daysDifference >= 30)
                return (<div className="validation-pass">{PWDates.getLocalDateString(revalidationDate)}</div>);
            else if (daysDifference < 30 && daysDifference > 0)
                return (<div className="validation-warn">{PWDates.getLocalDateString(revalidationDate)}</div>);
            else
                return (<div className="validation-fail">{PWDates.getLocalDateString(revalidationDate)}</div>);
        }
        else {
            return (<div className="validation-fail">NA</div>);
        }
    }

    //other
    function onMeasurementTypeInformationButtonClicked(e: any) {

        console.log("onMeasurementTypeInformationButtonClicked-----------------");
        console.log(e);

        if (e.row && e.row.data) {
            const infoMeasurementType = e.row.data as MeasurementType;

            if (infoMeasurementType) {
                setSelectedMeasurementType(infoMeasurementType);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: infoMeasurementType.measurementTypeId,
                    createTimestamp: infoMeasurementType.createTimestamp,
                    lastModifiedTimestamp: infoMeasurementType.modifyTimestamp,
                    createUser: infoMeasurementType.createUser,
                    modifyUser: infoMeasurementType.modifyUser
                };

                console.log("RESULT:");
                console.log(itemInformation);


                setItemBasicInformation(itemInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }
}
